/**
 * Application Constants
 */

// Agent ID to Name mapping
export const AGENT_NAMES = {
  3: 'Bill Processing',
  12: 'Sales Order (NetSuite)',
  13: 'Bank Statement',
  14: 'Email Router',
  15: 'Sales Order (Salesforce)'
};

// Get agent name by ID
export const getAgentName = (agentId) => {
  return AGENT_NAMES[agentId] || `Agent ${agentId}`;
};
